import { combineReducers } from 'redux';

import {
    AUTH_TOKEN_CHECK,
    RESET_TOKEN
} from '../actions/actionTypes';
import {
    SUBMIT_LOGIN_INFO_SUCCESS
} from '../../../components/Login/actions/actionTypes';
import {
    HOME_LOGOUT
} from '../../../components/Home/actions/actionTypes';

const initialState = {
    token: localStorage.getItem('rm-dash-token') ? localStorage.getItem('rm-dash-token') : '',
    userInfo: {}
};

const token = (state = initialState.token, action) => {
    switch(action.type) {
        case SUBMIT_LOGIN_INFO_SUCCESS:
            return action.token;
        case HOME_LOGOUT:
            return '';
        case RESET_TOKEN:
            return '';
        default:
            return state;
    }
}

const userInfo = (state = initialState.userInfo, action) => {
    switch(action.type) {
        case AUTH_TOKEN_CHECK:
            return action.userInfo;
        case HOME_LOGOUT:
            return {};
        default:
            return state;
    }
}

const auth = combineReducers({
    token,
    userInfo
});

export default auth;